import { FaClock, FaMapMarkerAlt, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaWifi, FaTv, FaBox, FaHeadset, FaHome, FaChartLine, FaFileInvoiceDollar, FaChartBar, FaSignal, FaUserCircle, FaUserCog } from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'internet plans':
      return <FaWifi />; // Wifi

    case 'cable packages':
      return <FaTv />; // Tv

    case 'bundled services':
      return <FaBox />; // Box

    case 'technical support':
      return <FaTools />; // Tools

    case 'customer care':
      return <FaHeadset />; // Headset

    case 'home installation':
      return <FaHome />; // Home


    /*----- position Icons -----*/
    case 'support agent':
      return <FaHeadset />; // Headset

    case 'network specialist':
      return <FaWifi />; // Wifi

    case 'sales manager':
      return <FaChartLine />; // Chart Line

    case 'service technician':
      return <FaTools />; // Tools

    case 'billing coordinator':
      return <FaFileInvoiceDollar />; // File Invoice Dollar

    case 'product analyst':
      return <FaChartBar />; // Chart Bar


    /*----- Help FAQs Icons -----*/
    case 'internet support':
      return <FaWifi />; // Wifi

    case 'cable tv support':
      return <FaTv />; // Tv

    case 'broadband support':
      return <FaSignal />; // Signal

    case 'account issues':
      return <FaUserCircle />; // User Circle

    case 'billing queries':
      return <FaDollarSign />; // Dollar Sign

    case 'service coverage':
      return <FaMapMarkerAlt />; // Map Marker Alt


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadengineer':
      return <FaUserCog />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    default: 
      return null; // Return null if no matching icon is found
  }

};